import React from 'react';
export default function Settings() {
  return (
    <div className="fade-in" style={{maxWidth:580}}>
      <h1 style={{marginBottom:24}}>Settings</h1>
      <div className="card card-pad" style={{marginBottom:16}}>
        <h3 style={{marginBottom:14}}>About ForgeIQ</h3>
        {[['Version','Phase 2 Build · March 2026'],['Engineering Rules','v2.1 — 60+ production drawings'],['Machines','6 fully characterised'],['Templates','A, B, B-S, C, D1, D2, D3, D4, D5, D6'],['Client','Singhania International Ltd / Sturdfix, Ludhiana']].map(([k,v])=>(
          <div key={k} style={{display:'flex',justifyContent:'space-between',padding:'7px 0',borderBottom:'1px solid var(--c-border)',fontSize:13}}>
            <span style={{color:'var(--t-muted)'}}>{k}</span><span style={{fontWeight:500}}>{v}</span>
          </div>
        ))}
      </div>
      <div className="card card-pad">
        <h3 style={{marginBottom:10}}>Data</h3>
        <p style={{fontSize:13,marginBottom:14}}>All job data stored locally in your browser. No server required for sequence generation.</p>
        <button className="btn btn-danger btn-sm" onClick={()=>{if(window.confirm('Clear all data?')){localStorage.clear();window.location.reload();}}}>Clear all data</button>
      </div>
    </div>
  );
}
